/* global __APP_BUILD_INFO__ */

const readRuntimeBuildInfoOverride = () => {
  const runtimeValue = typeof window !== 'undefined' ? window.__APP_BUILD_INFO__ : null;
  return runtimeValue && typeof runtimeValue === 'object' ? runtimeValue : {};
};

const readBundledBuildInfo = () => {
  if (typeof __APP_BUILD_INFO__ !== 'undefined' && __APP_BUILD_INFO__) {
    return __APP_BUILD_INFO__;
  }

  return {};
};

export function getLocalBuildInfo() {
  const override = readRuntimeBuildInfoOverride();
  const bundled = readBundledBuildInfo();
  const buildId = String(
    override.buildId ||
    bundled.buildId ||
    'development'
  );
  const builtAt = String(
    override.builtAt ||
    bundled.builtAt ||
    ''
  );

  return { buildId, builtAt };
}
